// A proportional bar. No Data/Meter component exists in the Figma file —
// every meter drawn there is a hand-built track/fill frame pair — so this
// archetype is authored rather than ported. Track 6px, pill radius,
// --bg-inset ground, 1px --border-subtle, clipped.
//
// The fill is sized HERE, in React, from a percentage this function computes.
// It carries no geometry from Figma, deliberately: in Figma a geometry
// override on a node nested inside an instance silently reverts, so a
// "resized" meter fill looks like it worked and did nothing. That trap does
// not cross into the port.
//
// `tone` is a prop and is never derived from the value, because which end of
// the scale is bad depends on the metric: 92% doc coverage is nominal, a 92%
// abandonment rate is not.

import "./ui.css";

export type MeterTone = "nominal" | "flagged" | "danger";

export type MeterBarProps = {
  value: number;
  max: number;
  tone?: MeterTone;
  /** Accessible name — a bare bar announces nothing. */
  label: string;
};

export function MeterBar({ value, max, tone = "nominal", label }: MeterBarProps) {
  const percent = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
  return (
    <div
      className="maisight-ui-meter"
      role="meter"
      aria-label={label}
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={max}
    >
      <div
        className="maisight-ui-meter-fill"
        data-tone={tone}
        style={{ width: `${percent}%` }}
      />
    </div>
  );
}
